import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { ModuleManagerExportFormat } from 'src/shared/models/module-manager/module-manager-options.model';

@Injectable({
    providedIn: 'root'
})
export class EvaluatorCalibrationService {

    constructor(
        private cvApiService: CVApiService,
    ) { }
    public async loadData(moduleKey: string, isAutoRefresh: boolean = false, isFirstLoad: boolean = false): Promise<any> {
        let renderEndpoint: string;
        try {
            renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
        } catch (error) {
            console.error("Failed getting module render endpoint");
            throw error;
        }
        try {
            const url = `/api/v2/dashboards/modules/evaluator-calibration/${encodeURIComponent(moduleKey)}`;
            const urlOptions = `?isAutoRefresh=${isAutoRefresh}&isFirstLoad=${isFirstLoad}`;
            const response = await this.cvApiService.get(url + urlOptions, renderEndpoint);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        } catch (erorr) {
            console.error("Failed getting data for evaluator calibration widget");
        }
    }

    public async getExport(moduleKey: string, format: ModuleManagerExportFormat, isCXOne: boolean) {
        let renderEndpoint: string;
        try {
            renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
        } catch (error) {
            console.error("Failed getting module render endpoint");
            throw error;
        }

        try {
            const url = `/api/v2/dashboards/modules/evaluator-calibration/${encodeURIComponent(moduleKey)}` +
                `/export?format=${format}` +
                `&isCXOne=${isCXOne}`;
            const response = await this.cvApiService.get<string>(url, renderEndpoint);
            if (response.status_code >= 200 && response.status_code < 300)
                return response;
            else throw response;
        } catch (error) {
            console.error("Failed getting data to export evaluator calibration widget");
            throw error;
        }
    }
}
